define('common/alertMessage',[
],
    function () {

        const alertSelector = "#alertMessage";
        const allButtonsSelector = alertSelector + " .modal-footer button";
        const positions = {
            center: "modal-dialog-centered",
            top: "modal-dialog-top"
        };
        const defaultOptions = {
            position: "center",
            customClass: ""
        };
        const buttonSelector = {
            ok: allButtonsSelector + ".ok",
            yes: allButtonsSelector + ".yes",
            no: allButtonsSelector + ".no",
            button1: allButtonsSelector + ".button1",
            button2: allButtonsSelector + ".button2"
        };

        function show(messageText, okCallback, options) {
            setIcon();
            setButtons("ok", okCallback);
            setOptions(options, "alert-show");
            displayAlert(messageText);
        }

        function info(messageText, okCallback, options) {
            setIcon("info");
            setButtons("ok", okCallback);
            setOptions(options, "alert-info");
            displayAlert(messageText);
        }

        function warning(messageText, okCallback, options) {
            setIcon("warning");
            setButtons("ok", okCallback);
            setOptions(options, "alert-warning");
            displayAlert(messageText);
        }
        
        function error(messageText, okCallback, displayDefaultMessage, options) {
            setIcon("error");
            setButtons("ok", okCallback);            
            setOptions(options, "alert-error");
            if (typeof messageText === 'undefined' || messageText === null) messageText = "";
            if (typeof displayDefaultMessage === 'undefined') displayDefaultMessage = true;
            if (displayDefaultMessage || messageText === "") {
                messageText = Rifton.Messages["General/Default Error Message"] + messageText;
            }
            displayAlert(messageText);
        }

        function yesNoQuestion(messageText, yesCallback, noCallback, options) {
            setIcon("question");
            setButtons("yes-no", yesCallback, noCallback);
            setOptions(options, "alert-yes-no");
            displayAlert(messageText);
        }

        function custom(messageText, iconName, callback1, buttonText1, callback2, buttontext2, options) {
            setIcon(iconName);
            setButtons("custom", callback1, callback2, buttonText1, buttontext2);
            setOptions(options, "alert-custom");
            displayAlert(messageText);
        }

        function spinner(messageText, iconName, options) {
            setIcon(iconName);
            $(alertSelector + " .spinner").removeClass("d-none");
            setButtons("none");
            setOptions(options, "alert-spinner");
            displayAlert(messageText);
        }

        function setIcon(iconName) {
            $(alertSelector + " .spinner").addClass("d-none");
            $(alertSelector + " .icons").addClass("d-none");
            $(alertSelector + " i").addClass("d-none");
            if (iconName) {
                $(alertSelector + " .icons").removeClass("d-none");
                $(alertSelector + " i." + iconName).removeClass("d-none");
            }
        }

        function setButtons(buttons, callback1, callback2, buttonText1, buttonText2) {
            $(allButtonsSelector).addClass("d-none");
            $(buttonSelector.ok).off("click");
            $(buttonSelector.yes).off("click");
            $(buttonSelector.no).off("click");
            $(buttonSelector.button1).off("click");
            $(buttonSelector.button2).off("click");
            if (buttons === "yes-no") {
                $(buttonSelector.yes).removeClass("d-none");
                $(buttonSelector.no).removeClass("d-none");
                $(buttonSelector.yes).on("click", function () { hideAndCallback(callback1); });
                $(buttonSelector.no).on("click", function () { hideAndCallback(callback2); });
            }
            else if (buttons === "custom") {
                if (callback1) {
                    $(buttonSelector.button1).removeClass("d-none");
                    $(buttonSelector.button1).text(buttonText1);
                    $(buttonSelector.button1).on("click", function () { hideAndCallback(callback1); });
                }
                if (callback2) {
                    $(buttonSelector.button2).removeClass("d-none");
                    $(buttonSelector.button2).text(buttonText2);
                    $(buttonSelector.button2).on("click", function () { hideAndCallback(callback2); });
                }
            }
            else if (buttons === "none") {

            }
            else {
                $(buttonSelector.ok).removeClass("d-none");
                $(buttonSelector.ok).on("click", function () { hideAndCallback(callback1); });
            }
        }

        var previousClasses;

        function setOptions(options, alertClass) {
            // setting position class
            var pos = (options && options.position) || defaultOptions.position;
            $(alertSelector + " .modal-dialog")
                .removeClass(positions.center).removeClass(positions.top)
                .addClass(positions[pos]);
            // setting CSS classes
            var cl = (alertClass ? alertClass : "") + " " +
                ((options && options.customClass) ? options.customClass : defaultOptions.customClass);
            if (previousClasses) $(alertSelector + " .modal-content").removeClass(previousClasses);
            if (cl) $(alertSelector + " .modal-content").addClass(cl)
            previousClasses = cl;
        }

        var alertMessageModal = null;
        var alertMessageIsInTransition = false;

        function getAlertModal() {
            if (!alertMessageModal) {
                // initializing alertModal
                var alertElement = document.querySelector(alertSelector);
                if (alertElement) {
                    alertMessageModal = new bootstrap.Modal(alertElement, { backdrop: "static", keyboard: false });
                    if (alertMessageModal) {
                        $(alertElement).on("show.bs.modal", () => { alertMessageIsInTransition = true; });
                        $(alertElement).on("shown.bs.modal", () => { alertMessageIsInTransition = false; });
                        $(alertElement).on("hide.bs.modal", () => { alertMessageIsInTransition = true; });
                        $(alertElement).on("hidden.bs.modal", () => { alertMessageIsInTransition = false; });
                    }
                    else console.log("Alert modal not initialized for " + alertSelector);
                }
                else console.log("There's no alert modal with selector " + alertSelector);
            }
            return alertMessageModal;
        }

        function displayAlert(messageText) {
            if (alertMessageIsInTransition) {
                // Alert is currently transitioning (it's being displayed or hidden). Come back a bit later to display it with new message.
                setTimeout(() => { displayAlert(messageText) }, 500);
            }
            else {
                $(alertSelector + " .alert-text").empty().html(messageText);
                var alertModal = getAlertModal();
                if (alertModal) {
                    alertModal.show();
                }
            }
        }


        function hideAndCallback(callback) {
            if (callback) $(alertSelector).one("hidden.bs.modal", callback);
            hide();
        }

        function hide() {
            if (alertMessageIsInTransition) {
                // Alert is currently transitioning (it's being displayed or hidden). Come back a bit later to hide it.
                setTimeout(() => { hide() }, 500);
            }
            else {
                // hide the modal
                var alertModal = getAlertModal();
                if (alertModal) {
                    alertModal.hide();
                }
            }
        }

        return {
            show: show,
            info: info,
            warning: warning,
            error: error,
            yesNoQuestion: yesNoQuestion,
            custom: custom,
            spinner: spinner,
            hide: hide
        };
    });

